import { Switch as SwitchPrimitive } from "radix-ui";
import { useId } from "react";

import { cx } from "@/lib/cx";

import styles from "./Switch.module.css";

export interface SwitchProps {
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string | undefined;
}

export function Switch({
  label,
  checked,
  onCheckedChange,
  disabled = false,
  className,
}: SwitchProps) {
  const id = useId();
  return (
    <span className={cx(styles.row, className)}>
      <label htmlFor={id} className={styles.label}>
        {label}
      </label>
      <SwitchPrimitive.Root
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
        className={styles.track}
      >
        <SwitchPrimitive.Thumb className={styles.thumb} />
      </SwitchPrimitive.Root>
    </span>
  );
}
